import { render, staticRenderFns } from "./DeductionRecord.vue?vue&type=template&id=5c816aec&scoped=true&"
import script from "./DeductionRecord.vue?vue&type=script&lang=js&"
export * from "./DeductionRecord.vue?vue&type=script&lang=js&"
import style0 from "./DeductionRecord.vue?vue&type=style&index=0&id=5c816aec&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c816aec",
  null
  
)

export default component.exports